import { Component, ElementRef, ViewChild, HostListener,OnInit  } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { GarageDetailsService } from '../main/garage-details/garage-details-service';
import { GoogleMapsModule, MapInfoWindow, MapMarker } from '@angular/google-maps';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { AfterViewInit } from '@angular/core';
import Swiper from 'swiper';
import { Navigation, Autoplay } from 'swiper/modules';
import { GlobalVariable } from '../main/globals';
import { Router, RouterModule } from '@angular/router';


@Component({
  selector: 'app-insurance-claim',
  standalone: true, // ⭐ REQUIRED
  imports: [CommonModule,FormsModule,ReactiveFormsModule,MatIconModule,GoogleMapsModule,RouterModule   ], // ⭐ Needed for *ngIf and mat-icon
  templateUrl: './insurance-claim.html',
  styleUrls: ['./insurance-claim.scss'] // ⭐ styleUrls (plural)
})
export class InsuranceClaim  {

  isNavbarWhite = false;
  showCta = false;
  showRequestBtn = false;
  isPageLoading = true;
  showQuickBookBtn = false;
  showQuickBooking = false; // used in template
  center: any;
  zoom: number = 14;
  marker: any;
  submitted = false;
  successMessage: string = '';
  isModalOpen = false;
  isSubmitting = false; 
  callbackForm: FormGroup;
  submittedName: string = '';
  submittedMobile: string = '';
  garageShortName: any;
  issue: any;
  userId = GlobalVariable.userId;
  private scrollInterval: any;
  showIssueDropdown = true;
  swiperInstance: any;
  serviceId: any;
   fromPage: any;
    services: any;
  mapOptions: google.maps.MapOptions = {
    disableDefaultUI: true,
    mapTypeControl: false,
    fullscreenControl: false,
    streetViewControl: false,
    zoomControl: true,
  };
  key: any;
    garageData: any = {
    reviews: [
      { comment: 'Great service!', rating: 5 },
      { comment: 'Very professional.', rating: 4.5 },
      { comment: 'Highly recommend!', rating: 5 },
      { comment: 'Quick and easy!', rating: 4 },
      { comment: 'Excellent!', rating: 5 }
    ]
  };

  @ViewChild('heroSection', { static: true }) heroSection!: ElementRef;
  @ViewChild(MapInfoWindow) infoWindow!: MapInfoWindow;
  @ViewChild('markerElem', { static: false }) markerElem!: MapMarker;
  @ViewChild('offcanvasNav') offcanvasNav!: ElementRef;

 
    constructor(
      private garageService: GarageDetailsService,
      private fb: FormBuilder,
      private router: Router  ) {
        this.callbackForm = this.fb.group({
        name: ['', Validators.required],
        mobile: ['', [Validators.required, Validators.pattern('^[0-9]{10}$')]],
        registrationNumber: ['', Validators.required],
        issue: ['']
      });
    }

  // 🔽 Called from buttons in HTML
  openRequestModal() {
    console.log('Request modal opened');
  }

ngOnInit() {
  this.key = localStorage.getItem('garageKey'); 

  console.log('Garage Key:', this.key);

  if (this.key) {
    this.loadGarageDetails();
  } else {
    console.error('Garage key missing in localStorage');
  }

  setTimeout(() => {
    this.isPageLoading = false;
  }, 800);
}

scrollTo(sectionId: string) {
  const el = document.getElementById(sectionId);
  if (el) {
    el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
  this.closeOffcanvas();
}
  // 🔽 Navbar + button scroll behavior
  @HostListener('window:scroll', [])
  onWindowScroll() {
    if (!this.heroSection) return;

    const heroBottom =
      this.heroSection.nativeElement.getBoundingClientRect().bottom;

    const heroHidden = heroBottom <= 80;

    this.isNavbarWhite = heroHidden;     // makes navbar white
    this.showRequestBtn = heroHidden;    // shows Book button in navbar
  }

  ngAfterViewInit(): void {

  const testimonialSwiper = new Swiper('.testimonial-swiper', {
    slidesPerView: 1,
    // loop: true,
    rewind: true,
    pagination: {
      el: '.swiper-pagination-testimonial',
      clickable: true,
    },
    navigation: {
      nextEl: '.swiper-button-next-new',
      prevEl: '.swiper-button-prev-new',
    },
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
  });

  // Makes / Cars Logos Swiper
 const makesSwiper = new Swiper('.makes-swiper-container', {
  slidesPerView: 1,
  loop: false,
  rewind: false,
  autoplay: false,

  navigation: {
    nextEl: '.swiper-button-next-makes',
    prevEl: '.swiper-button-prev-makes',
  },

  observer: true,
  observeParents: true,
});


   // 🔹 HERO SWIPER (ADD ONLY)
  const heroSwiper = new Swiper('.hero-swiper', {
  slidesPerView: 1,
  loop: true,

  autoplay: {
    delay: 5000,
    disableOnInteraction: false,
  },

  pagination: {
    el: '.swiper-pagination-hero',
    clickable: true,
  },

  observer: true,
  observeParents: true,
});



  // 🔹 HERO BUTTONS
  const heroNext = document.querySelector(
    '.hero-wrapper .swiper-button-next'
  ) as HTMLElement;

  const heroPrev = document.querySelector(
    '.hero-wrapper .swiper-button-prev'
  ) as HTMLElement;

  heroNext?.addEventListener('click', () => {
    heroSwiper.slideNext();
  });

  heroPrev?.addEventListener('click', () => {
    heroSwiper.slidePrev();
  });

  // Optional: update after init
  setTimeout(() => {
    testimonialSwiper.update();
    // makesSwiper.update();
  }, 300);

   const bookBtn = document.querySelector('.requestBtn-new') as HTMLElement;
  if (bookBtn) {
    const observer = new IntersectionObserver(
      ([entry]) => {
        // entry.isIntersecting is true when button is in view
        this.showQuickBooking = !entry.isIntersecting;
      },
      {
        root: null, // viewport
        threshold: 0.1, // 10% visible
      }
    );

    observer.observe(bookBtn);
  }

}
  ngAfterViewChecked() {
    if (
      this.garageData?.insuranceUrls?.length &&
      !this.swiperInstance
    ) {
      setTimeout(() => {
        this.initInsuranceSwiper();
      }, 100);
    }
  }

  loadGarageDetails() {
   this.isPageLoading = true;
    this.garageService.getGarageDetails(this.key).subscribe({
      next: (res) => {
        if (res.code === 200 && res.data) {
          this.garageData = res.data;
          
         
          //  garage logo
          if (this.garageData.garageLogo) {
            const logos = this.garageData.garageLogo
              .split(',')
              .map((l: string) => l.trim())
              .filter(Boolean);

          this.garageData.primaryLogo = this.garageData?.garageLogo
            ? this.garageData.garageLogo.split(',')[0].trim()
            : 'assets/img/logos/autoverse-logo-with-text.jpg';
          } else {
            this.garageData.primaryLogo = 'assets/img/logos/autoverse-logo-with-text.jpg';
          }
          if (this.garageData.insuranceUrl) {
            this.garageData.insuranceUrls = this.garageData.insuranceUrl.split(',').filter((url: any) => url);
          }

          if (this.garageData.insuranceUrl) {
            this.garageData.insuranceUrls = this.garageData.insuranceUrl
              .split(',')
              .filter((url: string) => url);
          }
            // Google maps Integration
            this.center = { lat: this.garageData?.latitude, lng: this.garageData?.longitude }; 
            this.marker = {
              position: { lat: this.garageData?.latitude, lng: this.garageData?.longitude },
              title: this.garageData?.name,
              options: { 
                animation: google.maps.Animation.DROP,
                icon: {
                  url: './assets/img/google_map_icon.png',
                  scaledSize: new google.maps.Size(30, 30)
                }
              },
              googleRatings: this.garageData?.googleRatings,
              googleReviewNumbers: this.garageData?.googleReviewNumbers,
              address: this.garageData?.address,
              mobileNumber: this.garageData?.mobileNumber
            };
            // Google maps Integration
          
        
          // populate visibleReviews for first time
          // this.updateVisibleReviews();
          // wait a tick to ensure marker is ready
          setTimeout(() => {
            if (this.markerElem) {
              this.infoWindow.open(this.markerElem);
            }
          }, 500);

                }
                this.isPageLoading = false;
              },
              error: (err) => console.error(err)
            });
  }
  initInsuranceSwiper() {
    if (this.swiperInstance) {
      this.swiperInstance.destroy(true, true);
    }

    this.swiperInstance = new Swiper('.insurance-swiper', {
      modules: [Navigation, Autoplay],
      loop: true,
      spaceBetween: 30,
      slidesPerView: 5,
      speed: 800,

      autoplay: {
        delay: 2000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true
      },

      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      },

      breakpoints: {
        320: { slidesPerView: 2 },
        640: { slidesPerView: 3 },
        1024: { slidesPerView: 5 }
      },

      observer: true,
      observeParents: true
    });
  }


      submitForm() {
        this.submitted = true;
    // Mark all fields as touched to trigger validation messages
    this.callbackForm.markAllAsTouched();

    // Stop if form is invalid
    if (this.callbackForm.invalid) {
      return;
    }

    // Check if garage is selected
    const garageKey = localStorage.getItem('garageKey');
    if (!garageKey) {
      alert("Garage not selected!");
      return;
    }

    const { name, mobile, email, issue,registrationNumber } = this.callbackForm.value;
    this.issue = "Periodic Service";
    if (this.fromPage === 'periodic') {
      this.issue = 'Periodic Service';
    } else if (this.fromPage === 'denting-painting') {
      this.issue = 'Denting & Painting';
    } else {
      this.issue = 'General Service';
    }

    // Prepare payload
    const payload = {
      garageKey: garageKey,
      serviceId: this.serviceId,
      userId: this.userId,
      name,
      phoneNumber: mobile,
      email, // optional
      issue: issue,
      registrationNumber: registrationNumber 

    };

    localStorage.setItem("serviceId",this.serviceId);


    this.garageService.createBooking(payload).subscribe({
      next: (res) => {
        if (res.code === 200) {
          // Set success message
          this.successMessage = `Thank you ${payload.name} for Your Interest and Consideration`;

          // Close request callback modal
          const requestModalEl = document.getElementById('requestCallBackModal');
          const requestModal = (window as any).bootstrap.Modal.getInstance(requestModalEl);
          requestModal?.hide();

          // Show success modal after a short delay
          setTimeout(() => {
            const successModalEl = document.getElementById('successModal');
            if (successModalEl) {
              const successModal = new (window as any).bootstrap.Modal(successModalEl);
              successModal.show();
            }
          }, 200);

          // Store the submitted name and mobile for navigation
          this.submittedName = name;
          this.submittedMobile = mobile;

          // Reset the form
          this.callbackForm.reset();
          this.submitted = false;

        } else {
          alert('Something went wrong. Please try again.');
        }
      },
      error: () => {
        alert('Error creating booking. Please try again.');
      }
    });
  }
  openModal(coupon: any) {
    // this.selectedCoupon = coupon;
    this.isModalOpen = true;
    console.log("Selected coupon:", coupon);
  }

  closeModal() {
    // this.selectedCoupon = null;
     this.isModalOpen = false;
  }
    closeSuccessModal() {
    // Close the success modal
    const successModalEl = document.getElementById('successModal');
    const successModal = (window as any).bootstrap.Modal.getInstance(successModalEl);
    successModal?.hide();

  }
    formatRegistrationNumber() {
  let value = this.callbackForm.get('registrationNumber')?.value || '';

  value = value.toUpperCase().replace(/[^A-Z0-9]/g, '');

  if (value.length > 2) value = value.slice(0, 2) + ' ' + value.slice(2);
  if (value.length > 5) value = value.slice(0, 5) + ' ' + value.slice(5);
  if (value.length > 8) value = value.slice(0, 8) + ' ' + value.slice(8, 12);

  this.callbackForm.get('registrationNumber')?.setValue(value, { emitEvent: false });
}
goToGarageDetails() {
  this.router.navigate(['/garage-details', this.key]);
}
  openInfo(marker: MapMarker) {
    this.infoWindow.open(marker);
  }
    get directionsLink() {
      return `https://www.google.com/maps/dir/?api=1&destination=${this.garageData?.latitude},${this.garageData?.longitude}`;
    }

  get largerMapLink() {
    return `https://www.google.com/maps/search/?api=1&query=${this.garageData?.latitude},${this.garageData?.longitude}`;
  }
    getStars(rating: number): string[] {
    const stars: string[] = [];
    const fullStars = Math.floor(rating);
    const hasHalf = rating % 1 >= 0.5;

    for (let i = 0; i < fullStars; i++) stars.push('full');
    if (hasHalf) stars.push('half');
    while (stars.length < 5) stars.push('empty');

    return stars;
  }
closeOffcanvas() {
  const offcanvasElement = this.offcanvasNav?.nativeElement;
  if (offcanvasElement) {
    const bsOffcanvas = (window as any).bootstrap.Offcanvas.getInstance(offcanvasElement);
    if (bsOffcanvas) {
      bsOffcanvas.hide();
    }
  }
}
goToServices() {
  sessionStorage.setItem('scrollToServices', 'true');
  this.router.navigate(['/garage-details', this.key]);
}
}
